const HOME_CATEGORY_BANNER_CLASS = {
    1: 'category-advantage',
    2: 'category-premium',
    3: 'category-elite',
};

new Vue({
    el: '#home-training-summary',
    data: {
        summary: {
            courses: {
                completed: 0,
                inProgress: 0,
                notStarted: 0,
            },
            tracks: {
                completed: 0,
                inProgress: 0,
                notStarted: 0,
            },
        },
    },
    created: function () {
        this.applyCategoryTheme();
        this.loadSummary();
    },
    methods: {
        async applyCategoryTheme() {
            if (!window.$getAccount) {
                return;
            }

            try {
                const account = await window.$getAccount;
                const categoryId = Number((account.category && account.category.id) || 1);
                const bannerClass = HOME_CATEGORY_BANNER_CLASS[categoryId] || HOME_CATEGORY_BANNER_CLASS[1];
                const $section = $('#home-training-summary');

                $section.removeClass('category-advantage category-premium category-elite');
                $section.addClass(bannerClass);
            } catch (error) {
                console.warn('Não foi possível aplicar o tema de categoria na seção de treinamentos.', error);
            }
        },
        goToSection(type) {
            const trainingType = type === 'tracks' ? 'trilhas' : 'treinamentos';
            window.location.href = `/treinamentos?type=${trainingType}`;
        },
        hasAuth() {
            return typeof $headerAuth !== 'undefined' && $headerAuth && $headerAuth.Authorization;
        },
        getCurrentUserId() {
            const rawUserId = localStorage.getItem('user_id');
            return rawUserId ? Number(rawUserId) : null;
        },
        isCompleted(subscriber) {
            if (!subscriber) return false;
            return subscriber.completed === true || Number(subscriber.completed) === 1;
        },
        isActive(item) {
            if (!item) return false;

            if (item.active === undefined || item.active === null) return true;

            return item.active === true || Number(item.active) === 1;
        },
        async fetchAll(endpoint, options = {}) {
            const includeMyCourse = options.includeMyCourse !== false;
            const userId = options.userId || null;
            const result = [];
            let page = 1;
            let lastPage = 1;

            do {
                const params = [
                    'active=1',
                    'per_page=100',
                    `page=${page}`,
                ];

                if (userId) {
                    params.push(`user_id=${userId}`);
                }

                if (includeMyCourse) {
                    params.unshift('mycourse=true');
                }

                const response = await axios.get(
                    `${api_url}${endpoint}?${params.join('&')}`,
                    { headers: $headerAuth }
                );

                const payload = response.data || {};
                const data = payload.data || [];
                lastPage = payload.last_page || 1;

                result.push(...data);
                page += 1;
            } while (page <= lastPage);

            return result;
        },
        classifyCourseStatus(course) {
            const subscriber = course ? course.subscriber : null;

            if (!subscriber) return 'notStarted';
            if (this.isCompleted(subscriber)) return 'completed';

            const watched = Number(subscriber.time_watched || 0);
            const tried = Number(subscriber.tried || 0);

            if (watched === 0 && tried === 0) return 'notStarted';

            return 'inProgress';
        },
        classifyTrackStatus(track) {
            const subscriber = track ? track.subscriber : null;

            if (!subscriber) return 'notStarted';
            if (this.isCompleted(subscriber)) return 'completed';

            const progress = Number(subscriber.progress || 0);
            const watched = Number(subscriber.time_watched || 0);
            const tried = Number(subscriber.tried || 0);

            if (progress === 0 && watched === 0 && tried === 0) return 'notStarted';

            return 'inProgress';
        },
        buildSummary(items, classifier) {
            return items.reduce(
                (acc, item) => {
                    const status = classifier(item);

                    if (status === 'completed') acc.completed += 1;
                    if (status === 'inProgress') acc.inProgress += 1;
                    if (status === 'notStarted') acc.notStarted += 1;

                    return acc;
                },
                {
                    completed: 0,
                    inProgress: 0,
                    notStarted: 0,
                }
            );
        },
        async loadSummary() {
            if (!this.hasAuth()) return;

            try {
                const userResponse = (typeof $getUser !== 'undefined' && $getUser)
                    ? await $getUser
                    : null;

                const user = userResponse && userResponse.data ? userResponse.data : null;
                const userId = (user && user.id) || this.getCurrentUserId();

                const [courses, tracks] = await Promise.all([
                    this.fetchAll('training', { includeMyCourse: false, userId }),
                    this.fetchAll('training/track', { includeMyCourse: false, userId }),
                ]);

                const standaloneCourses = courses.filter((course) => {
                    const isStandalone = !course.track_id;
                    return isStandalone && this.isActive(course);
                });

                const activeTracks = tracks.filter((track) => this.isActive(track));

                this.summary.courses = this.buildSummary(standaloneCourses, this.classifyCourseStatus);
                this.summary.tracks = this.buildSummary(activeTracks, this.classifyTrackStatus);
            } catch (error) {
                console.error('Erro ao carregar resumo de treinamentos da home:', error);
            }
        },
    },
});
